export function customSelect() {
    if ($("select").length) {
        jcf.setOptions("Select", {
            wrapNative: false,
            maxVisibleItems: 6,
            multipleCompactStyle: true
        });

        jcf.replaceAll();

        $(document).on('change', '.request-form select', function () {
            setTimeout(() => {
                jcf.replaceAll();
                $(".request-form select").blur()
            }, 10)
        })
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js